<template>
  <div>
    <span v-if="this.errors.size > 0">{{ this.errors[0] }}</span>

    <label for="user_name">Email</label>
    <input type="text" class="form-control" id="user_email" v-model="user.email">

    <label for="user_password">Password</label>
    <input type="password" class="form-control" id="user_password" v-model="user.password">

    <button v-on:click="createUser" type="button" class="btn btn-success">Create User</button>
  </div>
</template>

<script>

import { UserService } from '@/common/services/user.service';

export default {
  name: 'UserNew',
  components: {

  },
  data() {
    return {
      user: {
        email: '',
        password: '',
        role: 'Viewer',
      },
      errors: [],
    };
  },
  created() {},
  methods: {
    createUser() {
      UserService.create(this.user)
      .then(({ data }) => {
        this.$router.push({ name: 'UserShow', params: { id: data.id } }, () => {
          // Derp
        });
      })
      .catch((err) => { console.warn(err.response.data); this.errors = err.response.data.error; });
    },
  },
};

</script>

<style lang="scss" scoped>

</style>
